import React from 'react';
import { Card, Typography, Table, Tag } from 'antd';

const { Title } = Typography;

const mockUsers = [
  { key: '1', name: 'Eduardo Faccuseh', email: 'eduardo@grupofaza.com', role: 'admin', company: 'GRUPO FAZA' },
  { key: '2', name: 'Josafat Ramírez', email: 'josafat@grupofaza.com', role: 'admin', company: 'GRUPO FAZA' },
  { key: '3', name: 'Ilse Mendoza', email: 'ilse@grupofaza.com', role: 'manager', company: 'EL CAMELLO IMPORT' },
  { key: '4', name: 'Rodrigo Aguilar', email: 'rodrigo@grupofaza.com', role: 'manager', company: 'GRUPO FAZA' },
];

const roleColors = { admin: 'red', manager: 'blue', viewer: 'default' };

const columns = [
  { title: 'Nombre', dataIndex: 'name', key: 'name' },
  { title: 'Email', dataIndex: 'email', key: 'email' },
  { title: 'Rol', dataIndex: 'role', key: 'role', render: (role) => <Tag color={roleColors[role]}>{role}</Tag> },
  { title: 'Empresa', dataIndex: 'company', key: 'company' },
];

const Users = () => (
  <div>
    <Title level={3}>Usuarios</Title>
    <Card bordered={false} style={{ borderRadius: 8 }}>
      <Table columns={columns} dataSource={mockUsers} pagination={false} />
      <div style={{ marginTop: 16, color: '#999', fontSize: 12 }}>
        Los usuarios se sincronizan automáticamente desde Office 365 al iniciar sesión.
      </div>
    </Card>
  </div>
);

export default Users;
